export const parseHomeReadyContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'ready');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};

  if (!fields.title || !fields.text) {
    return null;
  }

  return {
    title: fields.title,
    text: fields.text,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '',
    },
  };
};
